import { render, staticRenderFns } from "./ProceduresFilter.vue?vue&type=template&id=ded9b97a"
import script from "./ProceduresFilter.vue?vue&type=script&lang=js"
export * from "./ProceduresFilter.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports